'use strict';

const processInclude = require('base/util');
window.jQuery = window.$ = require('jquery');

$(document).ready(() => {
    processInclude(require('./connectif/connectif'));
});
